import {
  get_appTheme31d66tq0vhtg5 as get_appTheme,
  app3jx72ykpxh7n4 as app,
} from './App.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { root1l5mhptocagam as root } from '../../../../kiteui-library/com/lightningkite/kiteui/root.mjs';
import { PageNavigator20tezdf2xr1uc as PageNavigator } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AutoRoutes2trt04tweryz2 as get_AutoRoutes } from './views/autoroutes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function main() {
  var tmp = get_appTheme();
  root(tmp, VOID, main$lambda);
}
function main$lambda($this$root) {
  app($this$root, new (PageNavigator())(main$lambda$lambda));
  return Unit_instance;
}
function main$lambda$lambda() {
  return get_AutoRoutes();
}
function mainWrapper() {
  main();
}
//region block: exports
export {
  mainWrapper as mainWrapper2g92l9we8tsl3,
};
//endregion

//# sourceMappingURL=Main.mjs.map
